import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import SectionDivider from "../shared/section-divider"
import {
  Container,
  Title,
  TitleDivider,
  TileContainer,
  FeatureCardContainer,
  FeatureCardText,
} from "./features-grid.style"
import Grid from "../shared/grid"

export default function FeaturesGrid() {
  const query = useStaticQuery(graphql`
    query {
      amenities: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Feature Cards/amenities.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      multi_destination: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Feature Cards/multi_destination.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      multifloor: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Feature Cards/multifloor.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      offline_mode: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Feature Cards/offline_mode.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      pan_zoom_rotate: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Feature Cards/pan_zoom_rotate.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      positioning: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Feature Cards/positioning.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      search: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Feature Cards/search.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      wayfinding: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/SDKS/Feature Cards/wayfinding.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <SectionDivider innerShadow={false} primaryColor="var(--slate)" />
      <Container>
        <Grid>
          <Title>Mapping SDK Features & Components</Title>
          <TitleDivider />
          <TileContainer>
            <FeatureCard
              fluidImage={query.search.childImageSharp.fluid}
              title="Search"
              alt="A partially filled search input box with results visible"
            />
            <FeatureCard
              fluidImage={query.wayfinding.childImageSharp.fluid}
              title="A-B Wayfinding"
              alt="A 3D map of a mall with a path drawn between two locations."
            />
            <FeatureCard
              fluidImage={query.positioning.childImageSharp.fluid}
              title="Indoor Positioning"
              alt="A map showing a navigation path and the user's current location represented as a blue dot."
            />
            <FeatureCard
              fluidImage={query.amenities.childImageSharp.fluid}
              title="Amenity Icons"
              alt="A 3D map with icons indicating the location of washrooms in a mall."
            />
            <FeatureCard
              fluidImage={query.multi_destination.childImageSharp.fluid}
              title="Multi-stop Wayfinding"
              alt="A 3D map of a mall with a path drawn between multiple locations."
            />
            <FeatureCard
              fluidImage={query.multifloor.childImageSharp.fluid}
              title="Multi-Floor Wayfinding"
              alt="A 3D map of a mall with a path drawn between locations on different floors."
            />
            <FeatureCard
              fluidImage={query.pan_zoom_rotate.childImageSharp.fluid}
              title="Pan - Zoom - Rotate"
              alt="Icons a user can select to pan, zoom, or rotate a map."
            />
            <FeatureCard
              fluidImage={query.offline_mode.childImageSharp.fluid}
              title="Offline Mode"
              alt="A WiFi icon with an exclamation point through it indicating no internet connection available."
            />
          </TileContainer>
        </Grid>
      </Container>
      <SectionDivider flip innerShadow={false} primaryColor="var(--slate)" />
    </>
  )
}

export const FeatureCard = ({ fluidImage, title, alt }) => {
  return (
    <FeatureCardContainer fluid={fluidImage}>
      <FeatureCardText aria-label={alt}>{title}</FeatureCardText>
    </FeatureCardContainer>
  )
}
